import { get } from 'lodash';

export default valueField => {
  const touched = get(valueField, 'touched');
  const error = get(valueField, 'error');

  return !(touched && error);
};
